import axios from 'axios'
import store from '../store'
import config from '../config'
import localStorage from '../core/local-storage'
import * as api from './config'

export default {
  request (method, uri, data = null, auth = false) {
    let headers = {}

    if (!method) {
      console.error('API function call requires method argument')
      return
    }

    if (!uri) {
      console.error('API function call requires uri argument')
      return
    }

    if (auth && localStorage.getToken()) {
      headers.authorization = 'Bearer ' + localStorage.getToken()
    }

    let _uri = (uri[uri.length - 1] === '/' ? uri.substring(0, uri.length - 1) : uri)
    let url = config.apiEndpoint + _uri

    return axios({ method, url, data, headers })
  },

  login (data) {
    return this.request('POST', api.login, data)
      .then((result) => {
        return result.data
      })
  },

  store (uri, data, auth) {
    let method = data.id > 0 ? 'PUT' : 'POST'
    let _uri = data.id > 0 ? uri.concat(data.id) : (uri[uri.length - 1] === '/' ? uri.substring(0, uri.length - 1) : uri)
    return this.request(method, _uri, data, auth)
  },

  post (uri, data, auth) {
    return this.request('POST', uri, data, auth)
      .then((result) => {
        return result.data
      })
  },

  delete (uri, data, auth) {
    let method = 'DELETE'
    uri = data && data.id && data.id > 0 ? uri.concat(data.id) : uri

    return this.request(method, uri, data, auth)
  },
  get (uri, auth) {
    return this.request('GET', uri, null, auth)
      .then((result) => {
        return result.data
      })
  },
  getJsonStatico () {
    // let method = 'GET'
    let uri = './static/json/static.json'
    return axios.get(uri)
  },
  // SIMA API
  getProyectos () {
    let uri = '/simaappproyectos'
    switch (store.state.user.role.name) {
      case 'Administrator':
      case 'Auditor':
        break
      default:
        let queryString = store.getters.getProyectosUsuario(true)
        if (queryString.length > 0) {
          uri = uri.concat('?').concat(queryString)
        } else {
          return Promise.resolve([])
        }
        break
    }
    return this.request('GET', uri, null, true)
      .then((result) => {
        return result.data
      })
  },
  getRoles () {
    return this.request('GET', '/users-permissions/roles', null, true)
      .then((result) => {
        let data = {}

        result.data.roles.forEach(function (role) {
          data[role.id] = {
            id: role.id,
            name: role.name,
            type: role.type
          }
        })

        localStorage.setKey('roles', data)
        store.commit('SYNC_API_DATA', {
          type: 'roles',
          items: data
        })
        return result.data
      })
  },
  getProyectoInfo (codigo) {
    let vm = this
    return new Promise(function (resolve, reject) {
      vm.request('GET', '/simaappproyectos?codigo_proyecto=' + codigo, null, true)
        .then((result) => {
          if (result.data.length > 0) {
            resolve(result.data[0])
          } else {
            reject(new Error('No se encontró la información solicitada'))
          }
        })
    })
  },
  getProyectoLink (codigo, tipo) {
    let vm = this
    return new Promise(function (resolve, reject) {
      vm.request('GET', '/simaapplinks?codigo_proyecto=' + codigo + '&tipo=' + tipo, null, true)
        .then((result) => {
          if (result.data.length > 0) {
            resolve(result.data)
          } else {
            reject(new Error('No se encontró la información solicitada'))
          }
        })
    })
  },
  getReportes (queryString) {
    let vm = this
    return vm.getTotalRegistros('simaappreportes', queryString)
      .then(total => {
        let _total = total
        return vm.request('GET', '/simaappreportes?' + queryString, null, true)
          .then((result) => {
            return Promise.resolve({
              data: result.data,
              total: _total
            })
          }, error => {
            return Promise.reject(error)
          })
      }, error => {
        return Promise.reject(error)
      })
  },
  saveReportes (data) {
    let vm = this
    let method = data._id ? 'PUT' : 'POST'
    let url = '/simaappreportes' + (data._id ? '/' + data._id : '')
    return vm.request(method, url, data, true)
      .then((result) => {
        return Promise.resolve(result.data)
      }, error => {
        return Promise.reject(error)
      })
  },
  getPartesDiarios (queryString) {
    let vm = this
    return vm.getTotalRegistros('simaappformpartediarios', queryString)
      .then(total => {
        let _total = total
        return vm.request('GET', '/simaappformpartediarios?' + queryString, null, true)
          .then((result) => {
            return Promise.resolve({
              data: result.data,
              total: _total
            })
          }, error => {
            return Promise.reject(error)
          })
      }, error => {
        return Promise.reject(error)
      })
  },
  getModeloParteDiario () {
    let vm = this
    return vm.request('GET', '/content-type-builder/models/simaappformpartediario', null, true)
      .then((result) => {
        return Promise.resolve(result.data.model)
      }, error => {
        return Promise.reject(error)
      })
  },
  savePartesDiarios (data) {
    let vm = this
    let method = data._id ? 'PUT' : 'POST'
    let url = '/simaappformpartediarios' + (data._id ? '/' + data._id : '')
    return vm.request(method, url, data, true)
      .then((result) => {
        return Promise.resolve(result.data)
      }, error => {
        return Promise.reject(error)
      })
  },
  getCompras (queryString) {
    let vm = this
    return vm.getTotalRegistros('simaappcompras', queryString)
      .then(total => {
        let _total = total
        return vm.request('GET', '/simaappcompras?' + queryString, null, true)
          .then((result) => {
            return Promise.resolve({
              data: result.data,
              total: _total
            })
          }, error => {
            return Promise.reject(error)
          })
      }, error => {
        return Promise.reject(error)
      })
  },
  saveCompras (data) {
    let vm = this
    let method = data._id ? 'PUT' : 'POST'
    let url = '/simaappcompras' + (data._id ? '/' + data._id : '')
    return vm.request(method, url, data, true)
      .then((result) => {
        return Promise.resolve(result.data)
      }, error => {
        return Promise.reject(error)
      })
  },
  getTotalRegistros (coleccion, queryString) {
    let vm = this
    return vm.request('GET', '/' + coleccion + '/count?' + queryString, null, true)
      .then((result) => {
        return Promise.resolve(result.data)
      }, error => {
        return Promise.reject(error)
      })
  },
  enviarEmail (data) {
    // let vm = this
    let header = {}
    let method = 'POST'
    let url = store.state.jsonStatic.emails.url

    data.sourceEmail = store.state.jsonStatic.emails.sourceEmail
    data.replyToAddresses = store.state.jsonStatic.emails.replyToAddresses
    data.bodyCharset = 'UTF-8'
    data.subjectCharset = 'UTF-8'

    return axios({ method, url, data, header })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js